import { useSignal } from "@preact/signals";
import { invoke } from "$store/runtime.ts";
import type { Product } from "apps/commerce/types.ts";

import { useRef } from "preact/hooks";
import Input from "$store/components/ui/Input.tsx";
import Icon from "$store/components/ui/Icon.tsx";
import Image from "apps/website/components/Image.tsx";

interface Props {
  productID: Product["productID"];
}

function Notify({ productID }: Props) {
  const nameInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const checkboxInputRef = useRef<HTMLInputElement>(null);

  const loading = useSignal(false);
  const successSubmit = useSignal(true);
  const errorInputText = useSignal({
    name: false,
    email: false,
    checkbox: false,
  });

  function isEmailValid() {
    const email = emailInputRef.current?.value;
    return email?.match(/^[^@]+@[^@]+\.[^@]+$/);
  }

  async function handleSubmit(e: Event) {
    e.preventDefault();
    const name = nameInputRef.current?.value;
    const email = emailInputRef.current?.value;
    const checkbox = checkboxInputRef.current?.checked;

    if (!name) {
      errorInputText.value = { ...errorInputText.value, name: true };

      setTimeout(() => {
        errorInputText.value = { ...errorInputText.value, name: false };
      }, 4000);

      return;
    }

    if (!email) {
      errorInputText.value = { ...errorInputText.value, email: true };
      setTimeout(() => {
        errorInputText.value = { ...errorInputText.value, email: false };
      }, 4000);
      return;
    }
    if (!isEmailValid()) {
      errorInputText.value = { ...errorInputText.value, email: true };
      setTimeout(() => {
        errorInputText.value = { ...errorInputText.value, email: false };
      }, 4000);
      return;
    }

    if (!checkbox) {
      errorInputText.value = { ...errorInputText.value, checkbox: true };
      setTimeout(() => {
        errorInputText.value = { ...errorInputText.value, checkbox: false };
      }, 4000);
      return;
    }

    try {
      loading.value = true;
      await invoke.vtex.actions.notifyme({ skuId: productID, name, email });
      successSubmit.value = false;
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  }

  return (
    <form
      class="form-control justify-start gap-2 relative"
      onSubmit={handleSubmit}
    >
      {successSubmit.value
        ? (
          <>
            <div class="">
              <span class=" text-2xl lg:text-[30px] text-tw-neutral-400 font-extrabold font-maven flex mb-2">
                O produto está indisponível no momento.
              </span>
              <span class="text-base font-normal text-tw-neutral-500 font-nunito flex mb-6">
                Preencha seus dados e te avisaremos assim que ele voltar para o
                estoque.
              </span>

              <div class="flex flex-col">
                <label
                  class="text-base  font-extrabold   mb-3 font-nunito"
                  for="name"
                >
                  {errorInputText.value.name
                    ? (
                      <span class="text-tw-danger-100">
                        Informe um nome válido
                      </span>
                    )
                    : <span class="text-tw-neutral-400">Informe seu nome</span>}
                </label>
                <Input
                  placeholder="Ex: Seu nome "
                  classes={`rounded-lg h-10 border  pl-3  mb-5 placeholder:text-base  ${
                    errorInputText.value.name
                      ? "placeholder:text-tw-danger-100 border-tw-danger-100"
                      : "placeholder:text-tw-neutral-300 border-tw-neutral-400"
                  }`}
                  name="name"
                  id="name"
                  inputRef={nameInputRef}
                />
                <label
                  class={`text-base font-extrabold   mb-3 font-nunito ${
                    errorInputText.value.email
                      ? ("text-tw-danger-100")
                      : ("text-tw-neutral-400")
                  }`}
                  for="email"
                >
                  Informe seu e-mail
                </label>
                <Input
                  placeholder="Ex: seuemail@seuemail.com.br"
                  classes={`rounded-lg  mb-6  h-10 border pl-3 placeholder:text-base ${
                    errorInputText.value.email
                      ? "placeholder:text-tw-danger-100 border-tw-danger-100"
                      : "placeholder:text-tw-neutral-300 border-tw-neutral-400"
                  }`}
                  name="email"
                  id="email"
                  inputRef={emailInputRef}
                />
                <div class="flex items-center gap-2 mb-6 ">
                  <div class="relative">
                    <input
                      ref={checkboxInputRef}
                      type="checkbox"
                      id={`checkbox-unavailable`}
                      checked={checkboxInputRef.current?.checked}
                      class={`z-10 opacity-0 h-5 w-5 absolute top-0  peer/unavailable`}
                    />
                    <span class=" flex h-5 w-5 rounded-md bg-tw-base-200 cursor-pointer mr-[6px]" />
                    <Icon
                      class={`h-5 w-5 rounded-md peer-checked/unavailable:opacity-100 cursor-pointer top-0 transition-opacity duration-300 opacity-0 absolute`}
                      id="CheckedBox"
                    />
                  </div>
                  <div>
                    <label
                      class={`text-sm font-semibold  font-nunito
              ${
                        errorInputText.value.checkbox
                          ? "text-tw-danger-100"
                          : "text-tw-neutral-500"
                      }
            `}
                      for="checkbox-unavailable"
                    >
                      Concordo com a{" "}
                      <a
                        href="/politica-de-privacidade"
                        class={`underline  font-extrabold font-nunito pr-1
                ${
                          errorInputText.value.checkbox
                            ? "text-tw-danger-100"
                            : "text-tw-neutral-500"
                        }
                `}
                      >
                        política de privacidade
                      </a>
                      e aceito receber notificações.
                    </label>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="rounded-lg text-xl w-full font-bold font-nunito text-white bg-tw-neutral-400 h-12 flex items-center justify-center transition-colors duration-300 hover:bg-tw-neutral-500"
                disabled={loading}
              >
                Avise-me quando chegar
              </button>
            </div>
          </>
        )
        : (
          <div class="mx-5">
            <div class="flex flex-col items-center text-center mb-20">
              <Image
                src={"https://decoims.com/saddicenter/88e5a71a-c9aa-4417-8126-c9b99c8fff97/494f7ec7_494f7ec7feb2fbb923b1b37892eef5a1.gif"}
                width={74}
                height={74}
                loading="lazy"
                fetchPriority="low"
              />
              <span class=" text-2xl lg:text-[30px] text-tw-neutral-400 font-extrabold font-maven flex mb-2 justify-center">
                Cadastro finalizado.
              </span>
              <span class="text-lg text-tw-neutral-400 font-medium font-maven">
                Agradecemos seu cadastro, avisaremos quando o produto voltar ao
                estoque
              </span>
            </div>
            <a
              href="/"
              target="_self"
              title="Voltar para a página inicial"
              alt="Voltar para a página inicial"
              class="rounded-lg text-xl w-full font-bold font-nunito text-white bg-tw-neutral-400 h-12 flex items-center justify-center transition-colors duration-300 hover:bg-tw-neutral-500"
            >
              Voltar
            </a>
          </div>
        )}
    </form>
  );
}

export default Notify;
